import React from "react";
import { Discuss } from "react-loader-spinner";

function ResponseLoader() {
  return (
    <div className="data-loader">
      <Discuss
        visible={true}
        height="20"
        width="20"
        ariaLabel="discuss-loading"
        wrapperStyle={{}}
        wrapperClass="discuss-wrapper"
        colors={["#23b4c3", "#23b4c3"]}
      />
    </div>
  );
}

export default ResponseLoader;
